var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarEpicIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#6B5CE8"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 5,
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarEpicIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_epic_icon.9cece2b34a1a459e136398a04fff174e.svg";